import {Injectable} from '@angular/core';
import {Subject} from 'rxjs';
import {NotyConfig} from '@components/noty/noty.component';
import {environment} from '@environments/environment';
import {NotyPosition} from '@components/noty/noty.enums';
import {Observable} from 'rxjs';
import {Observer} from 'rxjs';
import {map, take} from 'rxjs/operators';
import {ConfirmOptions} from '@components/confirm/confirm.component';

/**
 * Сервис уведомлений о системных событиях
 */

@Injectable()
export class EventsService {
    login$ = new Subject();
    logout$ = new Subject();

    /**
     * Показываем и скрываем уведомления
     * @type {Subject<NotyConfig>}
     */
    notyShow$ = new Subject<NotyConfig>();
    notyHide$ = new Subject();

    /**
     * Скрыть отображаемое уведомления, которые можно скрывать при редиректах
     */
    notyHideOnRouteChange$ = new Subject();

    /**
     * Показываем и скрываем прелоадер на всю страницу
     */
    pagePreloaderShow$ = new Subject<string>(); // передаем сообщение
    pagePreloaderHide$ = new Subject();

    /**
     * Событие показа подтверждения
     */
    confirmShow$ = new Subject<ConfirmOptions>();

    /**
     * Подтверждение пришло
     */
    _confirmed$ = new Subject<boolean>();

    /**
     * Показать подтверждение
     * @param options
     */
    showConfirm(options?: ConfirmOptions): Observable<boolean> {
        this.confirmShow$.next(options || {});
        return new Observable((observer: Observer<boolean>) => {
            this._confirmed$.pipe(
                take(1),
                map((v) => {
                    if (!v) {
                        throw new Error();
                    }
                    return v;
                })
            ).subscribe(() => {
                observer.next(true);
                observer.complete();
            }, (e) => {
                observer.error(e);
            });
        });
    }

    showPreloader(message = '') {
        /**
         * Перед отображением прелоадера скрываем все сообщения
         */
        this.notyHide$.next();
        this.pagePreloaderShow$.next(message);
    }

    hidePreloader() {
        this.pagePreloaderHide$.next();
    }

    showNoty(config: NotyConfig): void {
        this.notyShow$.next(config);
    }

    hideNoty(id?: string|number) {
        this.notyHide$.next(id);
    }

    /**
     * Отобразить ошибку Http запроса
     */
    showGeneralHttpError() {
        this.notyShow$.next({
            type: 'warning',
            title: 'Отсутсвует связь',
            content: `Внимание, в данный момент система не может получить, передать и сохранить данные.
                Попробуйте обновить страницу. Проверьте подключение к Интернету. <br>
                Мы знаем о проблеме, но вы можете помочь, сообщив в поддержку детали возникновения ошибки,
                это поможет нам быстрее её решить.`,
            position: NotyPosition.bottomCenter,
            controls: [
                {
                    title: 'Написать в поддержку',
                    href: environment.technicalSupportUrl
                }, {
                    title: 'Закрыть',
                    callback: () => {
                        this.notyHide$.next();
                    }
                }
            ]
        });
    }
}
